export default __webpack_public_path__ + "static/media/time2.f1cb8786.svg";